var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"defaultNav"}},[_c('div',{staticClass:"logo"},[_c('a',{attrs:{"href":"#"}},[_c('img',{attrs:{"src":require("@/assets/images/logodark.png"),"alt":"corenroll-logo"}})]),_c('div',{staticClass:"appIcons"})])])
}]

export { render, staticRenderFns }